import { CLIENT_USER_FILTERS_DEFAULT as DEFAUT } from "../clientFiltersDefault";

// Types de client (PER-2430). « Sans fiche » est réservé aux comptes internes.
export const TYPES_CLIENT = [
  { id: "", label: "Tous" },
  { id: "INDIVIDUAL", label: "Particulier", icon: "fa-user" },
  { id: "COMPANY", label: "Société", icon: "fa-building" },
  { id: "MIXED", label: "Mixte", icon: "fa-users" },
  { id: "NONE", label: "Sans fiche", icon: "fa-user-slash", interne: true },
];

export const typesClientPour = (myRole) =>
  TYPES_CLIENT.filter((t) => !t.interne || myRole !== "PARTNER");

export const typeClientLabel = (id) =>
  (TYPES_CLIENT.find((t) => t.id === id) || {}).label || id;

// Statuts de contrat de la barre repliée : ids du référentiel POLICIES_STATUS
// (0 « Vide / Non applicable » exclu), libellés du référentiel, icônes ici.
const ICONES_STATUT_CONTRAT = { 10: "fa-check", 20: "fa-pause", 30: "fa-ban" };

export const quickContractStatuses = (POLICIES_STATUS = []) =>
  POLICIES_STATUS.filter((s) => s.id).map((s) => ({
    id: s.id,
    label: s.name,
    icon: ICONES_STATUT_CONTRAT[s.id] || "fa-circle",
  }));

export const statutContratLabel = (id, POLICIES_STATUS = []) =>
  (POLICIES_STATUS.find((s) => Number(s.id) === Number(id)) || {}).name || String(id);

export const statutCompteLabel = (id, ACCOUNT_STATUS = []) =>
  (ACCOUNT_STATUS.find((s) => Number(s.id) === Number(id)) || {}).name || String(id);

// Portées du champ de recherche de la barre repliée : l'API n'a pas de
// recherche globale, chaque portée écrit dans un champ distinct.
export const SEARCH_SCOPES = [
  { id: "email", label: "Email", placeholder: "Adresse email…" },
  { id: "nomPrenomClient", label: "Nom, prénom", placeholder: "Nom ou prénom du client…" },
  { id: "nomSociete", label: "Société", placeholder: "Nom de l'entreprise…" },
  { id: "sirenOuSiret", label: "SIREN / SIRET", placeholder: "SIREN ou SIRET, sans espace…", normaliser: (v) => v.replace(/\s/g, "") },
  { id: "numeroContrat", label: "N° de contrat", placeholder: "Numéro de contrat…" },
];

// Portée affichée : celle choisie, sinon le premier champ texte renseigné
// (lien profond `?email=` ou `?sirenOuSiret=`), sinon Email.
export const scopeActif = (filtres, scopeChoisi) =>
  scopeChoisi || (SEARCH_SCOPES.find((s) => filtres[s.id]) || SEARCH_SCOPES[0]).id;

/**
 * Vues rapides. `build(ctx)` renvoie un PATCH partiel des champs pilotés.
 * ctx = { myRole }
 */
export const CLIENT_PRESETS = [
  {
    id: "PARTICULIERS",
    label: "Particuliers",
    icon: "fa-user",
    isAvailable: () => true,
    build: () => ({ typeClient: "INDIVIDUAL" }),
  },
  {
    id: "SOCIETES",
    label: "Sociétés",
    icon: "fa-building",
    isAvailable: () => true,
    build: () => ({ typeClient: "COMPANY" }),
  },
  {
    id: "SANS_FICHE",
    label: "Sans fiche",
    icon: "fa-user-slash",
    isAvailable: (ctx) => ctx.myRole !== "PARTNER",
    build: () => ({ typeClient: "NONE" }),
  },
  {
    id: "ECHEANCIER",
    label: "Avec échéancier",
    icon: "fa-calendar-check",
    isAvailable: () => true,
    build: () => ({ avecEcheancierOuMensualisation: true }),
  },
  {
    // ACCOUNT_STATUS 2 : mail d'activation envoyé, compte jamais activé.
    id: "COMPTE_NON_ACTIVE",
    label: "Compte non activé",
    icon: "fa-envelope-open",
    isAvailable: () => true,
    build: () => ({ statutCompte: 2 }),
  },
];

const sameSet = (a = [], b = []) =>
  a.length === b.length && [...a].sort().join("|") === [...b].sort().join("|");

/**
 * Une vue est active ssi chaque clé de son patch correspond à l'état :
 * tableaux ordre-insensibles, scalaires comparés après normalisation des
 * nombres (les statuts arrivent parfois en chaîne depuis l'URL).
 */
const memeValeur = (a, b) =>
  Object.is(a ?? "", b ?? "") ||
  (a !== "" && b !== "" && !isNaN(a) && !isNaN(b) && Number(a) === Number(b));

export const isPresetActive = (preset, filtres, ctx) =>
  Object.entries(preset.build(ctx)).every(([key, val]) =>
    Array.isArray(val) ? sameSet(filtres[key] || [], val) : memeValeur(filtres[key], val),
  );

// Patch qui remet à leur valeur par défaut les champs d'un patch donné.
export const emptyPatchFor = (patch) =>
  Object.keys(patch).reduce((acc, key) => {
    acc[key] = DEFAUT[key];
    return acc;
  }, {});
